export const BRIEF_GOOD_VIBES_SEGMENT = "brief/good-vibes";

export const BRIEF_GOOD_VIBES_PATH = `/${BRIEF_GOOD_VIBES_SEGMENT}`;
